module.exports = __webpack_public_path__ + "static/section3-54093dc284ebdd81486f95c3ca544ffc.png";